module.exports = __webpack_public_path__ + "static/media/lever.30bf4712.svg";